<template>
  <v-select class="service-code"
            v-model="selectedValue"
            :options="getServiceTypes"
            label="display_name"
            style="width: 200px;"
            @input="onInput"
            @change="onChange">
  </v-select>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import _ from 'underscore'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'change', 'input'])

const store = useStore()

// Tạo computed cho selectedValue để theo dõi thay đổi 2 chiều
const selectedValue = computed({
  get: () => {
    return _.find(getServiceTypes.value, st => st.id === Number(props.modelValue)) || null
  },
  set: (value) => {
    emit('update:modelValue', value?.id || null)
  }
})

// Computed
const getServiceTypes = computed(() => {
  const types = store.getters['session/getServiceTypes']
  return types
})

// Methods
const onChange = (event) => {
  emit('change', event)
}

const onInput = (value) => {
  emit('input', value)
}

// Watchers
watch(() => props.modelValue, (newVal, oldVal) => {
}, { immediate: true })

// Lifecycle hooks
onMounted(() => {
})
</script>

<style scoped>

</style>
